import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatCategoryPromoterModel } from 'src/app/model/cat-category-promoter.model';
import { CatCategoryPromoterService } from 'src/app/services/cat-category-promoter.service';
import { CreatorService } from 'src/app/services/creator.service';
import { ModalCategoryPromoterComponent } from 'src/oldApp/shared/modal-category-promoter/modal-category-promoter.component';

@Component({
  selector: 'app-cat-category-promoter',
  templateUrl: './cat-category-promoter.component.html',
  styleUrls: ['./cat-category-promoter.component.css']
})
export class CatCategoryPromoterComponent implements OnInit {
  // estado pagina
  public page:string='CatCategoryPromoter';
  public viewStatus=0;  // -1:nada, 0:spinner, 1:tabla
  public categories:CatCategoryPromoterModel[]=[];

  // opciones datatables
  dtOptions={
    order:[],
    responsive:true,
    columnDefs: [
      { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  ////////////////
  constructor(
    private creator:CreatorService,
    private modalService:NgbModal,
    private categoryPromoterService:CatCategoryPromoterService,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  // 
  add=()=> {
    let category=this.creator.newCatCategoryPromoter();
    let modalRef=this.modalService.open(ModalCategoryPromoterComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.category=category;
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='create';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }
  edit=(category:CatCategoryPromoterModel)=> {
    let modalRef=this.modalService.open(ModalCategoryPromoterComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.category={...category};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='edit';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }

  // info
  getCatalogs=()=> {
    this.categoryPromoterService.getAll()
      .pipe(
        tap((resp:any)=> {
          this.categories=resp.data;
          this.viewStatus=1;
        }),
        catchError(error=> {
          // TODO
          this.viewStatus=-1;
          return of(this.toastr.error('Ocurrió un error al leer el catálogo de categorías.'));
        })
      )
      .subscribe();
  }
}